import React, { memo } from 'react';
import Link from 'next/link';

import { ITypo } from '@/app/_components/common';
import { ChevronDown, NavActiveIcon } from '@/app/assets/Icons';
import { cn } from '@nextui-org/react';

interface IProps {
	label: string;
	href: string;
	isScrolled: boolean;
	isActive: boolean;
	hasMegaNav?: boolean;
	onOpenChange?: (open: boolean) => void;
}

const NavItem: React.FC<IProps> = (props) => {
	return (
		<li className="lg:py-3">
			<Link
				href={props.href}
				className={cn(
					'col group relative items-center gap-1 p-3 focus:outline-none xl:px-6'
				)}
				onClick={() => {
					props.onOpenChange?.(false);
				}}
			>
				<div className="row-between gap-2">
					<ITypo
						size={16}
						title={props.label}
						className={cn(
							`group-hover:text-bittersweet lg:text-16 text-14 block whitespace-nowrap text-nowrap text-center before:block before:h-0 before:overflow-hidden before:font-semibold before:content-[attr(title)] group-hover:font-semibold `,
							{
								'group-hover:text-white sm:text-white':
									props.isScrolled,
								'text-bittersweet font-semibold':
									props.isActive,
							}
						)}
					>
						{props.label}
					</ITypo>

					{props.hasMegaNav && (
						<ChevronDown
							className={cn(
								'text-gray group-hover:text-bittersweet size-4 transition-all group-hover:-rotate-90',
								{
									'text-bittersweet -rotate-90':
										props.isActive,
									'!text-white group-hover:text-white':
										props.isScrolled,
								}
							)}
						/>
					)}
				</div>

				<div
					className={cn(
						'group-hover:text-bittersweet absolute -bottom-0 h-[6px] w-10 shrink-0 translate-y-2 opacity-0 transition-all group-hover:translate-y-0  group-hover:opacity-100',
						{
							'!text-white group-hover:text-white':
								props.isScrolled,
							'text-bittersweet translate-y-0 opacity-100':
								props.isActive,
						}
					)}
				>
					<NavActiveIcon />
				</div>
			</Link>
		</li>
	);
};

export default memo(NavItem);
